var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStufiInside(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 320.56 569",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #dbdbdb;\n      }\n\n      .cls-3 {\n        fill: #37474f;\n      }\n\n      .cls-4 {\n        fill: #455a64;\n      }\n\n      .cls-5 {\n        fill: #a6a6a6;\n      }\n\n      .cls-6 {\n        fill: #c7c7c7;\n      }\n\n      .cls-7 {\n        opacity: .3;\n      }\n\n      .cls-7, .cls-8, .cls-9 {\n        isolation: isolate;\n      }\n\n      .cls-10 {\n        fill: #767676;\n      }\n\n      .cls-11 {\n        fill: #272727;\n      }\n\n      .cls-12 {\n        fill: #898989;\n      }\n\n      .cls-8 {\n        opacity: .2;\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-14 {\n        fill: #ebebeb;\n      }\n\n      .cls-15 {\n        fill: #ffc727;\n      }\n\n      .cls-16 {\n        fill: none;\n      }\n\n      .cls-17 {\n        fill: #9c927f;\n      }\n\n      .cls-9 {\n        opacity: .1;\n      }\n\n      .cls-18 {\n        fill: #fed234;\n      }\n\n      .cls-19 {\n        fill: #263238;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    width: 320.56,
    height: 569
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0,
    width: 320.56,
    height: 569
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m66.11,218l-17.53.37-8.88.12c-2.98.07-5.96,0-8.95.08h-.6v-16.15h.65l17.68.08c5.89,0,11.77.16,17.67.22h.37v.35c0,2.54-.12,5.05-.17,7.55l-.25,7.39Zm0,0l-.18-7.55c0-2.49-.14-4.94-.17-7.39l.35.35c-5.89,0-11.77.21-17.67.22l-17.68.08.65-.65v14.94l-.59-.58c2.92,0,5.82,0,8.75.07l8.78.14,17.76.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m46.4,236.8l-17.53.37-8.89.16c-2.97,0-5.96,0-8.93.07h-.59v-16.18h.67l17.67.09c5.9,0,11.77.14,17.68.21h.35v.35c0,2.54-.12,5.06-.17,7.55l-.26,7.39Zm0,0l-.2-7.53c0-2.5-.14-4.96-.17-7.4l.37.37c-5.9.07-11.77.2-17.68.21l-17.67.08.65-.65-.08,14.94-.58-.58c2.9,0,5.82,0,8.74.07l8.79.16,17.83.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m282.99,426.49l-17.53.37-8.89.14c-2.97.07-5.96,0-8.93.08h-.59v-16.18h.67l17.67.08c5.9,0,11.77.16,17.68.22h.35v.35c0,2.54-.12,5.05-.17,7.55l-.26,7.39Zm0,0l-.2-7.55c0-2.49-.14-4.94-.17-7.39l.37.35c-5.9,0-11.77.21-17.68.22l-17.67.08.65-.65v14.94s-.59-.58-.59-.58c2.9,0,5.82,0,8.74.07l8.79.14,17.76.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m263.27,445.28l-17.53.37-8.89.16c-2.97,0-5.95,0-8.93.07h-.56v-.59l-.07-14.94v-.65h.65l17.67.09c5.9,0,11.77.14,17.68.21h.35v.35c0,2.54-.12,5.06-.17,7.55l-.21,7.39Zm0,0l-.18-7.53c-.07-2.5-.16-4.96-.18-7.4l.37.37c-5.9.07-11.77.2-17.68.21l-17.67.08.65-.65-.08,14.94-.58-.58c2.92,0,5.82,0,8.74.07l8.79.16,17.83.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m302.7,445.28l-17.53.37-8.88.16c-2.98,0-5.96,0-8.95.07h-.58v-.59l-.08-14.94v-.65h.65l17.68.09c5.89,0,11.77.14,17.67.21h.37v.35c0,2.54-.12,5.06-.17,7.55l-.2,7.39Zm0,0l-.18-7.53c0-2.5-.14-4.96-.17-7.4l.35.37c-5.89.07-11.77.2-17.67.21l-17.68.08.65-.65-.1,14.94-.59-.58c2.92,0,5.82,0,8.75.07l8.78.16,17.87.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m310.39,74.46l-17.53.37-8.89.14c-2.97.07-5.95,0-8.93.08h-.58v-16.18h.65l17.68.08c5.89,0,11.77.16,17.67.22h.37v.35c0,2.54-.1,5.05-.17,7.55l-.27,7.39Zm0,0l-.18-7.55c-.07-2.49-.14-4.94-.17-7.39l.35.35c-5.9,0-11.77.21-17.67.22l-17.68.08.65-.65-.07,14.94-.59-.58c2.92,0,5.82,0,8.74.07l8.79.14,17.83.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m290.67,93.3l-17.53.37-8.89.16c-2.97,0-5.95,0-8.93.07h-.58v-.59l-.08-14.94v-.65h.65l17.68.09c5.89,0,11.77.14,17.67.21h.37v.35c0,2.54-.1,5.06-.17,7.55l-.2,7.39Zm0,0l-.18-7.55c-.07-2.49-.14-4.94-.17-7.39l.35.37c-5.89,0-11.77.2-17.67.21l-17.71.08.65-.65-.07,14.94-.59-.58c2.92,0,5.82,0,8.75.07l8.78.16,17.85.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m330.12,93.3l-17.53.37-8.89.16c-2.97,0-5.95,0-8.93.07h-.59v-.59l-.07-14.94v-.65h.65l17.67.09c5.9,0,11.77.14,17.68.21h.35v.35c0,2.54-.12,5.06-.17,7.55l-.18,7.39Zm0,0l-.18-7.55c-.07-2.49-.16-4.94-.18-7.39l.37.37c-5.9,0-11.77.2-17.68.21l-17.67.08.65-.65-.08,14.94-.58-.58c2.92,0,5.82,0,8.74.07l8.79.16,17.83.35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m66.17,26.48l-17.53.37-8.89.14c-2.97,0-5.95,0-8.93.08h-.59v-.59l-.07-14.94v-.65h.65l17.67.09c5.9,0,11.77.14,17.68.21h.35v.35c0,2.54-.12,5.06-.17,7.55l-.18,7.39Zm0,0l-.18-7.55c-.07-2.49-.16-4.94-.18-7.39l.37.37c-5.9,0-11.77.2-17.68.21l-17.67.08.65-.65-.08,14.94-.58-.58c2.92,0,5.82,0,8.74.07l8.79.16,17.83.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m137.55,46.98l-17.53.37-8.89.14c-2.97,0-5.95,0-8.93.08h-.59v-.59l-.07-14.94v-.65h.65l17.67.09c5.9,0,11.77.14,17.68.21h.35v.35c0,2.54-.12,5.06-.17,7.55l-.18,7.39Zm0,0l-.18-7.55c-.07-2.49-.16-4.94-.18-7.39l.37.37c-5.9,0-11.77.2-17.68.21l-17.67.08.65-.65-.08,14.94-.58-.58c2.92,0,5.82,0,8.74.07l8.79.16,17.83.35Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 103.6,
    y: 152.72,
    width: 142.93,
    height: 175.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 109.64,
    y: 167.77,
    width: 4.81,
    height: 154.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m252.63,334.04H97.56v-187.35h155.07v187.35Zm-142.93-12.09h130.84v-163.18H109.64l.05,163.18Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 103.6,
    y: 257.11,
    width: 142.93,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 103.6,
    y: 211.6,
    width: 142.93,
    height: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 206.54,
    y: 164.29,
    width: 5.54,
    height: 94.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 172.3,
    y: 164.29,
    width: 5.54,
    height: 94.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 138.05,
    y: 164.29,
    width: 5.54,
    height: 94.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 92.38,
    y: 145.67,
    width: 165.37,
    height: 22.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.38,
    y: 145.67,
    width: 165.37,
    height: 15.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 84.76,
    y: 134.62,
    width: 180.61,
    height: 22.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m26.67,532.89c91.39-.78,184.62-1.07,276.02-.09,0,0,0,.68,0,.68-68.51.83-138.61.78-207.01.54-17.15-.06-51.84-.28-69-.44,0,0,0-.68,0-.68h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "98.32 438.42 99.95 451.81 110.95 533.47 108.51 533.47 93.39 451.81 91.16 438.42 98.32 438.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "54.66 451.81 56.29 438.42 63.46 438.42 61.23 451.81 46.11 533.47 43.67 533.47 54.66 451.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "63.46 438.42 61.23 451.81 54.66 451.81 56.29 438.42 63.46 438.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "9.31 451.81 10.94 438.42 18.1 438.42 15.87 451.81 .75 533.47 -1.68 533.47 9.31 451.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "10.94 438.42 18.1 438.42 15.87 451.81 9.31 451.81 10.94 438.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "6.4 334.66 57.56 334.66 71.5 433.03 112.99 433.03 112.99 444.71 2.18 444.71 6.4 334.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.22 444.71 112.99 444.71 112.99 433.03 8.63 433.03 8.22 444.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.4 334.66 12.15 334.66 8.22 444.71 2.18 444.71 6.4 334.66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Devices--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 69.9,
    y: 365.21,
    width: 59.58,
    height: 2.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 99.49,
    y: 365.21,
    width: 29.99,
    height: 2.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m104.28,359.78l4.96-25.8c.62-3.21,3.43-5.53,6.7-5.53h44.18c4.28,0,7.51,3.9,6.7,8.11l-4.97,25.8c-.62,3.21-3.43,5.53-6.7,5.53h-44.17c-4.28,0-7.51-3.9-6.7-8.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m135.88,344.63c.13,0,.25,0,.38.02,1.75.2,3,1.78,2.8,3.52-.2,1.98-1.85,3.5-3.84,3.53-.12,0-.25,0-.37-.02-1.75-.19-3.01-1.77-2.81-3.51.2-1.98,1.85-3.51,3.84-3.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Lamp--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "221.13 301.87 192.51 286.16 193.27 284.77 222.59 300.87 230.68 362.32 229.11 362.52 221.13 301.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m221.86,299.13h0c-1.23,0-2.23,1-2.23,2.23s1,2.23,2.23,2.23,2.23-1,2.23-2.23-1-2.23-2.23-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m193.2,283.23h0c-1.23,0-2.23,1-2.23,2.23s1,2.23,2.23,2.23,2.23-1,2.23-2.23-1-2.23-2.23-2.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "184.66 283.36 188.61 280.82 196.48 289.59 193.53 293.24 188.68 299.22 178.19 287.51 184.66 283.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "184.66 283.36 193.53 293.24 188.68 299.22 178.19 287.51 184.66 283.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "179.72 282.9 193.42 298.21 181.28 313.7 162.98 293.29 179.72 282.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "217.19 359.38 240.93 359.38 242.59 367.88 215.52 367.88 217.19 359.38"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    y: 0,
    width: 320.56,
    height: 569
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shelf--inject-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 268.91,
    y: 275.59,
    width: 7.65,
    height: 257.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 276.56,
    y: 275.59,
    width: 5.7,
    height: 257.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 276.57,
    y: 310.53,
    width: 82.05,
    height: 7.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 268.91,
    y: 368.67,
    width: 89.69,
    height: 7.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 268.91,
    y: 426.79,
    width: 89.69,
    height: 7.65
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-7--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m307.65,476.13c11.83,11.58,13.82,29.5,11.32,45.19-.07.36-.62.26-.62-.08,0-3.57.1-7.11.1-10.64l-.18-.48c-3.09-2.24-5.93-4.78-7.69-8.26-1.97-3.88-2.75-8.26-4.26-12.32-.14-.39.27-.28.54-.08,7.2,5.31,9.49,11.02,11.56,18.65-.04-3.99-.46-7.97-1.25-11.89-1.56-7.25-4.63-14.42-9.84-19.79-.18-.21.1-.52.32-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m305.42,477.48c-2.04.07-3.31,3.32-4.89,4.27-.65.53-1.61.44-2.14-.21-.04-.04-.07-.09-.1-.14-1.58-2.19.58-4.9,2.61-6.42-1.45.6-2.66,1.65-4.22,1.94-.77.25-1.59-.17-1.85-.93-.02-.07-.04-.14-.05-.21-.69-2.99,3.06-4.35,5.63-4.35-1.25-.87-4.82-3.23-2.93-4.35s6.1,2.21,7.49,3.32c2.01,1.64,4.41,4.08,4.5,6.63.12,2.92-2.48,1.09-4.05.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m305.42,477.48c-2.04.07-3.31,3.32-4.89,4.27-.65.53-1.61.44-2.14-.21-.04-.04-.07-.09-.1-.14-1.58-2.19.58-4.9,2.61-6.42-1.45.6-2.66,1.65-4.22,1.94-.77.25-1.59-.17-1.85-.93-.02-.07-.04-.14-.05-.21-.69-2.99,3.06-4.35,5.63-4.35-1.25-.87-4.82-3.23-2.93-4.35s6.1,2.21,7.49,3.32c2.01,1.64,4.41,4.08,4.5,6.63.12,2.92-2.48,1.09-4.05.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m306.02,477.99c-2.61-1.18-7.6.51-8.03-.47-.87-2,3.13-3.38,5.29-3.65-1.99-.53-5.79-1.39-5.67-3.31.14-2.33,5.83-.32,8.71,1.89,3.63,2.78,3.61,5.47,3,6-.82.74-2.87-.27-3.3-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m322.05,504.36c-.83,5.95-2.1,11.83-3.81,17.59-.05.24-.28.4-.52.35s-.4-.28-.35-.52c.8-5.43,2.27-10.74,3.07-16.16.88-5.47,1.2-11.01.96-16.55-.51-9.13-3-18.85-8.95-25.99-.13-.17.15-.41.28-.25,11.93,13.93,10.03,30.97,10.02,32.5,1.69-5.76,3.43-12.37,9.82-18.23.27-.25.49-.14.44.3-1.14,10.68-4.11,16.26-10.31,21.97-.17,1.65-.39,3.34-.66,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m312.34,464.63c-2.14-.95-5.1,1.79-7.23,1.97-.93.23-1.88-.34-2.11-1.27-.02-.07-.03-.15-.04-.23-.53-3.07,3.07-4.79,5.94-5.34-1.8-.11-3.58.37-5.36-.1-.95-.16-1.59-1.06-1.43-2,0-.05.02-.09.03-.14.79-3.48,5.36-2.94,8.05-1.74-.87-1.52-3.38-5.77-.83-6.02s5.22,5.37,6.1,7.21c1.26,2.71,2.53,6.44,1.34,9.14-1.38,3.18-3.15-.04-4.47-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m312.34,464.63c-2.14-.95-5.1,1.79-7.23,1.97-.93.23-1.88-.34-2.11-1.27-.02-.07-.03-.15-.04-.23-.53-3.07,3.07-4.79,5.94-5.34-1.8-.11-3.58.37-5.36-.1-.95-.16-1.59-1.06-1.43-2,0-.05.02-.09.03-.14.79-3.48,5.36-2.94,8.05-1.74-.87-1.52-3.38-5.77-.83-6.02s5.22,5.37,6.1,7.21c1.26,2.71,2.53,6.44,1.34,9.14-1.38,3.18-3.15-.04-4.47-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m312.7,465.45c-2.11-2.53-8.15-3.28-8.1-4.52.11-2.52,4.95-1.93,7.32-1.12-1.79-1.56-5.3-4.35-4.22-6.29,1.33-2.36,6.23,2.61,8.1,6.34,2.37,4.72.99,7.49.1,7.75-1.22.35-2.85-1.74-3.2-2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m308.4,533.11l-5.22-28.04h32.02c-.66,2.49-6.62,28.07-6.62,28.07l-20.18-.03Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants-6--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m308.73,381.79s-3.25-2.45-1.79-3.56c.5-.38,1.63.87,1.79,2.2.17-1.37,1.3-2.61,1.8-2.2,1.45,1.12-1.8,3.56-1.8,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m308.73,381.79s-3.25-2.45-1.79-3.56c.5-.38,1.63.87,1.79,2.2.17-1.37,1.3-2.61,1.8-2.2,1.45,1.12-1.8,3.56-1.8,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m308.73,381.79c-1.96,0-3.41-1.79-2.97-2.56s2.26,1.2,2.26,1.2c0,0-.66-2.95.71-2.95s.71,2.95.71,2.95c0,0,1.74-2.09,2.27-1.2s-1.02,2.56-2.98,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m303.18,402.86l-.31,7.15c-2.6-.21-5.06-1.22-7.04-2.91-1.44-1.44-1.06-5.89-.26-11.39s2.38-6.15,3.7-5.83c.32.06.62.21.87.42.71.62,1.01,1.74,1.12,3.24.17,1.96-.64,7.1-.42,8.31.05.31.23.58.5.74.58.25,1.22.34,1.85.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m314.14,412.77c-3.75,1.2-7.77,1.2-11.52,0,0,0,.56-22.72,1.27-26.53s2.33-5.64,4.93-5.64h.5c2.06.22,3.48,1.8,3.94,4.82.34,2.31.64,15.09.78,22.33.06,2.95.1,5.02.1,5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m320.94,399.85c-1.98,1.69-4.45,2.71-7.04,2.91l-.31-7.15c.44,0,2.17.22,2.39-1s-.58-6.36-.43-8.32.64-3.34,1.96-3.66l.34-.05c1.25-.12,2.61.87,3.37,5.88.35,2.43.62,4.65.69,6.5.08,2.35-.16,4.09-.96,4.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m308.73,380.58c.09,0,.17.03.24.08.07.05.14.11.2.17.11.14.2.29.29.44.16.31.29.63.39.97.2.67.35,1.36.47,2.05.23,1.38.36,2.76.45,4.15s.14,2.79.17,4.18l.08,4.17c0,2.79.07,5.56.09,8.35v8.35c-.06-1.39-.1-2.79-.14-4.17l-.11-4.18c-.07-2.78-.1-5.56-.17-8.34s0-5.57-.17-8.34c-.07-1.39-.17-2.78-.37-4.15-.09-.69-.22-1.37-.4-2.04-.09-.34-.2-.66-.35-.98-.07-.16-.16-.3-.26-.44-.06-.07-.12-.13-.18-.18-.07-.05-.15-.08-.24-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m312.82,413.13c0-1.39-.06-2.79-.09-4.17l-.06-4.18-.09-8.35c0-1.39,0-2.78-.07-4.17v-1.04l-.04-1.04c0-.7-.09-1.39-.15-2.08s-.13-1.38-.24-2.07c-.09-.69-.22-1.37-.39-2.04-.16-.68-.43-1.32-.78-1.92-.18-.29-.4-.57-.64-.81-.26-.24-.55-.43-.87-.58.32.15.61.34.87.57.26.23.49.5.67.8.37.6.65,1.24.83,1.92.35,1.35.59,2.73.71,4.13.14,1.38.24,2.78.29,4.17s.08,2.79.1,4.18.04,2.78.04,4.17v8.36c-.04,1.38-.06,2.78-.1,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m308.73,380.58c-.09,0-.17.04-.24.09-.07.05-.13.12-.18.18-.11.14-.2.29-.27.44-.14.32-.26.64-.35.98-.18.67-.31,1.35-.4,2.04-.19,1.38-.3,2.76-.37,4.15-.14,2.77-.12,5.56-.17,8.34s-.1,5.56-.17,8.34l-.1,4.18c-.05,1.38-.09,2.78-.15,4.17v-8.35c0-2.79.06-5.56.09-8.35l.08-4.17c0-1.39.07-2.79.17-4.18s.23-2.78.45-4.15c.12-.69.28-1.38.48-2.05.1-.33.23-.66.38-.97.08-.16.18-.31.3-.44.06-.07.12-.13.19-.17.07-.05.16-.08.25-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m304.63,413.13c0-1.39-.06-2.79-.08-4.17l-.04-4.18v-8.35c0-1.39.06-2.79.1-4.18s.15-2.79.29-4.17c.12-1.39.36-2.77.71-4.13.18-.68.46-1.32.83-1.92.19-.3.42-.57.68-.8.26-.23.55-.42.87-.57-.32.15-.61.35-.87.58-.24.25-.46.52-.64.81-.35.6-.6,1.25-.77,1.92-.18.67-.31,1.35-.4,2.04-.1.69-.17,1.38-.24,2.07s-.11,1.38-.15,2.08v2.08c0,1.39-.06,2.78-.07,4.17l-.09,8.35-.06,4.18c-.02,1.38-.04,2.78-.08,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m308.73,413.68c0-1.38-.05-2.76-.08-4.14v-24.82c0-1.38.04-2.76.08-4.15,0,1.38.05,2.76.08,4.15l.04,4.14v16.55l-.04,4.14c-.03,1.38-.04,2.75-.08,4.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m299.26,389.88c.14.12.27.25.38.39.11.15.19.32.26.49.14.34.23.7.29,1.06.09.73.12,1.46.1,2.19-.06,1.46-.19,2.91-.4,4.35-.11.71-.19,1.43-.23,2.15-.05.71,0,1.43.16,2.12.08.34.22.67.42.96.1.14.21.27.34.38.13.12.28.22.44.3.32.17.66.28,1.01.35.36.07.72.12,1.08.15-.37,0-.73-.02-1.1-.07-.37-.04-.72-.14-1.06-.29-.34-.17-.64-.41-.87-.71-.23-.3-.4-.65-.5-1.01-.18-.72-.26-1.46-.22-2.2.03-.73.11-1.46.22-2.19.1-.72.19-1.44.27-2.16s.16-1.44.2-2.16c.05-.72.05-1.45,0-2.17-.03-.36-.1-.71-.21-1.05-.11-.35-.31-.66-.57-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m299.02,389.8c-.12.03-.22.09-.31.17-.09.08-.17.16-.24.25-.14.19-.26.39-.37.61-.2.43-.37.88-.49,1.34-.24.92-.42,1.86-.53,2.81-.23,1.91-.44,3.81-.51,5.72-.05.95,0,1.9.12,2.85.06.46.18.92.35,1.35.2.42.47.8.8,1.12.69.65,1.5,1.17,2.37,1.55.87.39,1.79.68,2.73.87-.96-.13-1.89-.38-2.79-.74-.91-.35-1.75-.86-2.47-1.52-.36-.34-.66-.74-.87-1.19-.19-.46-.32-.93-.4-1.42-.13-.96-.18-1.93-.14-2.9.09-1.92.29-3.84.59-5.74.13-.96.34-1.9.62-2.83.15-.46.34-.9.56-1.33.12-.21.25-.41.41-.6.08-.1.17-.18.27-.25.09-.07.19-.11.3-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m317.55,382.63c-.26.24-.45.54-.57.87-.11.34-.18.7-.21,1.05-.05.72-.05,1.45,0,2.17,0,.72.11,1.45.2,2.16s.17,1.45.27,2.16c.11.72.18,1.45.22,2.19.04.74-.03,1.48-.22,2.2-.1.36-.27.71-.5,1.01-.11.15-.25.29-.39.41-.15.12-.31.22-.48.3-.34.15-.7.25-1.06.3-.36.04-.73.06-1.1.06.37,0,.72-.08,1.08-.15.35-.06.69-.18,1.01-.35.15-.08.3-.18.44-.3.13-.12.24-.25.34-.39.2-.29.34-.62.42-.96.16-.7.21-1.41.16-2.12-.04-.72-.11-1.44-.23-2.15-.21-1.44-.34-2.9-.4-4.35-.03-.73,0-1.47.1-2.19.05-.36.15-.72.29-1.06.07-.17.16-.33.26-.48.11-.14.23-.26.37-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m317.79,382.56c.12.03.23.08.32.16.1.07.19.15.27.24.15.19.29.39.41.6.22.43.41.88.56,1.34.28.92.49,1.87.62,2.82.31,1.9.5,3.82.59,5.74.04.97,0,1.94-.14,2.9-.08.49-.21.96-.4,1.42-.21.45-.51.85-.87,1.19-.72.65-1.56,1.17-2.47,1.52-.9.36-1.83.61-2.79.74.94-.18,1.85-.48,2.73-.87.87-.38,1.67-.9,2.37-1.55.34-.32.61-.7.8-1.12.17-.43.29-.89.35-1.35.13-.94.17-1.9.12-2.85-.06-1.91-.28-3.81-.51-5.71-.11-.95-.29-1.89-.53-2.81-.12-.46-.28-.92-.49-1.35-.1-.21-.22-.42-.37-.61-.08-.09-.16-.17-.24-.25-.09-.09-.21-.16-.33-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m304.63,384.58c.17.2.32.41.44.64.07.11.13.23.19.34l.18.34h-.27l.25-.3c.09-.1.17-.19.27-.28.18-.18.38-.36.58-.51-.11.23-.24.46-.39.67-.07.11-.16.21-.23.31s-.16.21-.24.3l-.16.19-.1-.23c-.06-.11-.11-.24-.17-.35s-.1-.24-.14-.36c-.1-.25-.18-.51-.23-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m305.52,384.21c.04.15.06.3.07.45,0,.15,0,.3,0,.44-.02.15-.05.29-.09.44-.04.15-.1.29-.18.43-.04-.15-.06-.3-.07-.45-.01-.15-.01-.3,0-.44.02-.15.05-.29.09-.44.04-.15.1-.29.18-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m310.22,406.47c.19.18.36.38.51.58.09.1.16.21.24.31l.21.32h-.27l.22-.32.24-.3c.16-.21.33-.4.52-.58-.08.25-.19.49-.31.71-.06.11-.12.23-.19.34s-.13.22-.2.33l-.13.21-.14-.22c-.07-.1-.13-.22-.2-.33s-.12-.22-.18-.34c-.12-.23-.22-.47-.3-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m311.06,406c.06.14.1.29.12.44.04.29.04.58,0,.87-.02.15-.07.3-.12.44-.06-.14-.11-.29-.12-.44-.04-.29-.04-.58,0-.87.02-.15.06-.3.12-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m310.57,379.54c.09.24.16.49.21.75,0,.13,0,.26.07.38l.05.38-.24-.12.34-.19.34-.17c.24-.11.48-.21.73-.29-.19.18-.39.35-.6.51l-.31.22-.33.21-.22.12v-1.01c-.03-.26-.04-.52-.03-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m311.53,379.49c0,.15-.04.31-.09.45-.04.14-.1.28-.17.41-.06.13-.14.26-.23.38-.09.13-.19.24-.3.34,0-.15.03-.31.08-.45.05-.14.11-.28.17-.41.06-.13.14-.26.23-.38.09-.13.19-.24.3-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m316.02,390.27c.22.13.43.28.64.44l.3.24.28.26-.25.07c.04-.12.08-.25.13-.37l.15-.36c.11-.24.23-.47.37-.69-.03.26-.07.51-.14.77,0,.13-.07.25-.1.37s-.08.24-.12.37l-.08.24-.18-.17-.27-.28c-.09-.09-.18-.18-.26-.28-.17-.2-.33-.41-.47-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m316.72,389.62c.09.12.17.26.23.4.05.14.1.28.13.42.03.15.06.29.08.44.02.15.02.3,0,.45-.1-.12-.17-.26-.23-.4-.06-.13-.11-.27-.14-.42-.04-.14-.06-.29-.07-.44-.02-.15-.02-.31,0-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m316.61,381.5c.22.13.44.28.64.44l.3.24.29.26-.26.07.13-.37c.05-.12.1-.24.16-.36.1-.24.23-.47.37-.69-.02.26-.07.52-.14.77,0,.13-.06.25-.1.37s-.08.24-.12.37l-.08.24-.18-.17-.27-.28-.26-.28c-.17-.2-.33-.41-.47-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m317.3,380.85c.09.12.17.26.23.4.12.28.19.57.21.87.02.15.02.3,0,.45-.09-.12-.17-.26-.23-.4-.06-.14-.1-.28-.14-.42-.03-.14-.05-.29-.07-.44-.02-.16-.02-.31,0-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m311.61,387.91c.2.17.38.35.56.55l.25.3.24.3h-.27l.19-.33c.08-.11.14-.23.22-.33.14-.22.3-.42.48-.61-.07.25-.16.49-.26.73-.05.12-.11.24-.17.35l-.18.35-.12.22-.15-.2c-.07-.1-.15-.21-.22-.32s-.15-.21-.21-.32c-.14-.22-.26-.44-.36-.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m312.41,387.39c.07.13.12.28.15.43.04.15.06.29.07.44.01.15.01.3,0,.44.12.07.15.22.08.33-.07.12-.22.15-.33.08s-.15-.22-.08-.33c.02-.03.05-.06.08-.08-.03-.15-.05-.3-.06-.44-.01-.15-.01-.3,0-.44.01-.15.04-.29.1-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m302.01,390.88c.26.03.51.07.77.13l.37.1.37.12-.21.17v-.78c-.03-.26-.03-.52,0-.78.08.24.15.49.2.75,0,.13.04.26.07.38s0,.25.04.38v.24l-.24-.08-.37-.13-.36-.15c-.23-.1-.45-.23-.66-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m302.37,389.99c.14.07.26.16.37.27.11.1.21.21.3.32.09.12.17.24.24.37.13-.02.26.07.28.2s-.07.26-.2.28c-.13.02-.26-.07-.28-.2,0-.04,0-.08.01-.12-.11-.1-.21-.21-.3-.32-.09-.12-.18-.24-.25-.37-.08-.13-.14-.28-.17-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m294.12,396.54c.26.03.51.07.77.13.13,0,.25.07.37.1l.37.11-.21.17v-.78c0-.26.01-.52.05-.78.08.24.15.49.2.75,0,.13.04.26.06.38s0,.25.05.38v.25l-.24-.09-.37-.13-.36-.15c-.25-.1-.49-.22-.71-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m294.48,395.65c.14.07.26.17.37.27.11.1.21.21.3.32.2.23.34.5.44.79-.13-.07-.25-.16-.35-.27-.11-.1-.21-.2-.3-.32-.09-.11-.18-.24-.25-.37-.09-.13-.15-.28-.2-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m307.89,393.14c.19.18.37.37.52.58.09.1.16.2.24.3l.21.32h-.26c.07-.1.14-.22.22-.32s.15-.21.23-.3c.16-.21.33-.4.52-.58-.08.25-.19.48-.31.71l-.18.34-.21.33-.13.21-.13-.21c-.07-.11-.14-.22-.2-.33l-.19-.34c-.12-.23-.22-.47-.31-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m308.73,392.66c.06.14.1.29.12.44.04.29.04.58,0,.87-.02.15-.06.3-.12.44-.06-.14-.1-.29-.12-.44-.04-.29-.04-.58,0-.87.02-.15.07-.3.12-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m299.16,407.9c.26-.06.51-.09.78-.1.13,0,.26,0,.38,0h.39l-.15.22c-.05-.11-.1-.24-.15-.36l-.13-.37c-.08-.25-.14-.5-.18-.76.16.21.3.43.42.66l.17.35.16.35.1.23h-1.02c-.26-.05-.52-.12-.77-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m299.24,406.94c.15.03.3.08.44.15.14.06.26.13.38.22.13.08.24.17.35.28.12.1.22.22.3.35-.15-.03-.3-.08-.44-.15-.13-.06-.26-.13-.38-.22-.12-.08-.24-.18-.35-.28-.11-.1-.21-.22-.3-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m299.26,394.3c.19.17.37.37.52.57.09.1.16.21.24.31l.21.32h-.26c.07-.11.14-.22.22-.32l.23-.31c.16-.21.33-.4.52-.57-.08.25-.19.48-.31.71l-.18.34-.21.32-.13.22-.13-.22-.2-.32-.17-.33c-.13-.23-.24-.47-.33-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m300.1,393.82c.06.14.11.29.12.44.04.29.04.58,0,.87-.02.15-.06.3-.12.44-.06-.14-.1-.29-.12-.44-.04-.29-.04-.58,0-.87.02-.15.07-.3.12-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m318.01,398.38c.03.26.03.52,0,.78v.77l-.21-.17.37-.1c.12-.04.25-.07.37-.09.25-.06.51-.09.78-.1-.23.13-.46.24-.71.34l-.36.14-.37.11-.24.08v-.24c0-.13,0-.26.06-.38l.08-.38c.06-.25.13-.5.22-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m318.95,398.56c-.04.15-.11.29-.19.42-.08.13-.16.25-.26.36-.1.11-.2.22-.31.32-.12.1-.24.19-.38.25.05-.15.12-.29.2-.42.07-.13.16-.25.26-.36.09-.11.2-.22.3-.32.12-.1.25-.18.38-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m305.58,402.36c.19.18.37.37.52.58l.24.3.21.32h-.26l.21-.32.24-.3c.16-.21.33-.41.52-.58-.08.25-.19.48-.31.71l-.18.34-.2.32-.13.21-.13-.21c-.07-.11-.14-.22-.2-.33s-.13-.23-.19-.34c-.13-.23-.23-.46-.32-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m306.42,401.88c.06.14.1.29.12.44.04.29.04.58,0,.87.11.07.15.21.08.32-.07.11-.21.15-.32.08-.11-.07-.15-.21-.08-.32.02-.03.05-.06.08-.08-.04-.29-.04-.58,0-.87.02-.15.06-.3.12-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m295.56,401.47c.19.18.37.37.52.58.09.1.16.21.24.31l.22.31h-.27l.22-.31c.07-.1.15-.22.23-.31.16-.21.33-.4.52-.58-.08.25-.19.48-.31.71l-.18.34-.2.33-.14.21-.13-.21c-.07-.1-.14-.22-.2-.33s-.13-.22-.19-.34c-.12-.23-.22-.47-.31-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m296.39,401c.06.14.1.28.12.44.01.15.01.3,0,.44,0,.15,0,.3,0,.44-.02.15-.07.3-.13.44-.06-.14-.1-.29-.12-.44-.04-.29-.04-.58,0-.87.03-.16.07-.31.13-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m296.73,392.54s-3.02,0-2.66-1.31c.12-.45,1.33-.24,2.04.5-.51-.87-.38-2.11.09-2.1,1.35,0,.53,2.91.53,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m296.73,392.54s-3.02,0-2.66-1.31c.12-.45,1.33-.24,2.04.5-.51-.87-.38-2.11.09-2.1,1.35,0,.53,2.91.53,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m296.73,392.54c-1.17.87-2.82.47-2.91-.19s1.88-.3,1.88-.3c0,0-1.74-1.45-.87-2.06s1.74,1.43,1.74,1.43c0,0,.11-2.02.81-1.74s.51,1.99-.65,2.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m319.76,384.7s-1.59-2.56-.29-2.94c.44-.13.87,1.02.65,2,.48-.87,1.58-1.44,1.83-1.04.71,1.15-2.19,1.98-2.19,1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m319.76,384.7s-1.59-2.56-.29-2.94c.44-.13.87,1.02.65,2,.48-.87,1.58-1.44,1.83-1.04.71,1.15-2.19,1.98-2.19,1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m319.76,384.7c-1.36-.52-1.89-2.15-1.37-2.57s1.25,1.44,1.25,1.44c0,0,.33-2.21,1.27-1.85s-.3,2.22-.3,2.22c0,0,1.74-.97,1.89-.22s-1.38,1.5-2.74.98Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "299.7 413.09 316.08 413.09 314.43 426.78 301.35 426.78 299.7 413.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "299.7 413.09 300.08 416.19 315.8 415.43 316.08 413.09 299.7 413.09"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 298.68,
    y: 411.36,
    width: 18.43,
    height: 2.45
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-5--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m307.58,335.88c5.74,7.77,11.72,16.79,13.18,26.53-.02.07-.09.11-.16.09-.05-.01-.08-.05-.09-.09-.66-2.65-1.51-5.26-2.53-7.79-3.78-1.04-7.48-1.9-9.46-5.63s-1.74-8.87-1.38-13.06c.03-.18.3-.19.45-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m317.88,354.58c-2.53-5.92-5.93-11.43-10.09-16.34,0,0-.07,0-.04.04,2.63,3.39,4.93,7.02,6.89,10.83-1.9-1.93-3.98-3.66-5.78-5.7,0,0-.09,0-.05.06,1.74,2.3,3.8,4.35,6.1,6.1.63,1.15,1.25,2.31,1.89,3.48l-.48-.24s-.05,0,0,.04c.17.1.35.18.53.26.3.55.6,1.1.91,1.65.04.05.21-.05.13-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m315.99,352.56c-1.54-.86-3.02-1.84-4.41-2.93m-.05.05c1.35,1.16,2.82,2.17,4.4,3,.03.02.07,0,.09-.03s0-.07-.03-.09l-4.46-2.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m321.41,360.97c0,.06-.05.1-.11.1-.06,0-.1-.05-.1-.1,0-3.2,0-6.43-.05-9.65-.82-1.66-2.61-2.61-3.81-3.91-.88-.97-1.65-2.04-2.28-3.19-1.48-2.74-2.39-5.75-2.66-8.85-.34-3.44.96-14.76,2.4-14.37.76.2,3.18,5.82,3.82,7.67,1.05,3.06,1.82,6.2,2.29,9.4,1.03,7.59,1.2,15.27.5,22.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m321.44,347.13h0c-.3-4.08-.95-8.13-1.94-12.1-.92-4.24-2-8.24-4.19-12.02,0-.07-.14,0-.1.06,1.45,2.95,2.58,6.04,3.36,9.23-.15-.24-.32-.44-.48-.66-.06-.09-.2,0-.14.08.19.34.42.67.68.97h0c.76,3.03,1.3,6.1,1.74,9.23l-.1-.12s-.06,0-.05,0,.12.21.19.31c.23,1.57.44,3.13.66,4.68-2.87-2.31-5.11-5.31-6.53-8.71h0c1.18,3.64,3.49,6.81,6.6,9.05.06.42.11.87.17,1.25,0,.04.04.08.08.08.04,0,.08-.03.08-.08v-1.11s.03-.09,0-.12c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m320.12,341.24c-2.19-3.08-4.11-6.36-5.73-9.78,0-.04-.08,0-.07,0,1.28,3.6,3.2,6.94,5.66,9.87.08.05.18-.02.14-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m317.29,330.64c-.87-1.57-1.82-3.09-2.66-4.68m-.07,0c.69,1.67,1.57,3.25,2.61,4.73.04.02.09,0,.11-.03,0,0,0,0,0-.01l-2.73-4.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "309.63 368.67 333.94 368.67 331.98 358.99 331.54 356.86 312.03 356.86 311.59 358.99 309.63 368.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "311.39 360.01 331.98 358.99 331.54 356.86 312.03 356.86 311.39 360.01"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 309.48,
    y: 355.05,
    width: 24.6,
    height: 2.57
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-4--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m314.65,241.66s.5,0,1.06,2.19c.3,1.18-1.52,11.25-1.33,21.94.13,8.02.52,16.8,1.13,21.77,0,0,.59,1.18,2.52.82-1.54-7.54-2.38-15.21-2.52-22.91-.08-7.52,1.45-16.1,1.4-21.94.02-.71.19-1.4.5-2.04l-2.76.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m316.43,238.88c-1.31-1.02-2.1-2.57-2.16-4.23-.03-2.14.77-4.2,2.23-5.76,1.25-1.2,1.68-1.15,1.68-1.15,0,0,1.4-.19,2.26,2.75s1.69,5.43.68,6.97c-.95,1.63-2.99,2.25-4.68,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m316.43,238.88c-1.31-1.02-2.1-2.57-2.16-4.23-.03-2.14.77-4.2,2.23-5.76,1.25-1.2,1.68-1.15,1.68-1.15,0,0,1.4-.19,2.26,2.75s1.69,5.43.68,6.97c-.95,1.63-2.99,2.25-4.68,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m312.65,235.06s-.97-2.49-.09-4.35,1.51-1.9,1.7-1.94,1.42.3,1.87,2.12c.41,1.24.47,2.58.16,3.85-.3.75-1.49,1.31-1.49,1.31-.84.06-1.65-.31-2.15-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m312.65,235.06s-.97-2.49-.09-4.35,1.51-1.9,1.7-1.94,1.42.3,1.87,2.12c.41,1.24.47,2.58.16,3.85-.3.75-1.49,1.31-1.49,1.31-.84.06-1.65-.31-2.15-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m312.8,229.89s-1.02.27-1.31,2.01c-.18,1.39-.12,2.79.19,4.15.1.37.39,3.95,2.26,5.38s2.23.54,2.23.54c.99-.69,1.6-1.81,1.65-3.02.16-1.81-.02-3.63-.55-5.36-.51-1.53-.71-2.39-1.74-2.94s-2.37-.96-2.73-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m312.8,229.89s-1.02.27-1.31,2.01c-.18,1.39-.12,2.79.19,4.15.1.37.39,3.95,2.26,5.38s2.23.54,2.23.54c.99-.69,1.6-1.81,1.65-3.02.16-1.81-.02-3.63-.55-5.36-.51-1.53-.71-2.39-1.74-2.94s-2.37-.96-2.73-.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m317.52,242.39s-2.26.36-2.91-2.87.12-4.29.27-4.75,0-.96.32-1.52.58-.43,1.04-1.17.59-1.85.96-2.15c.32-.33.77-.5,1.23-.45.66.21,1.31.48,1.92.8.54.21.38,1.25.74,1.69.96,1.17,1.32,2.71.97,4.18-.44,2.46-.74,4.11-1.83,5.04-.72.72-1.69,1.15-2.71,1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m314.32,242.23c-.39.06-1.32.1-2.46-1.3-1.39-1.74-1.25-4.13-1.34-4.75-.1-1.2-.3-2.39-.59-3.56-.34-.93-.25-1.45-.15-1.52s.95.25,1.39,1.35,1.41,2.11,1.57,3.71.08,3.92.97,4.88,1.85.72,1.63,1.17c-.07.08-.76,0-1.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m315.1,267.76s-1.34-4.35,2.86-12.25,7.99-10.26,7.99-10.26c0,0,0,4.41-3.73,11.72s-6.56,10.46-7.12,10.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m323.89,248.6c.12-.23.17,0,.05.22-1.49,2.8-6.63,11.27-8.29,17.1-.07.24-.27,0-.18-.25,3.27-9.83,6.91-14.21,8.42-17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m320.74,261.17s-.76-5.47-2.5-6.57-2-.67-2.46-.7c-.52.1-1.02.3-1.47.58,0,0,2.33.08,3.13,1.52l3.29,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m320.74,261.17s-.76-5.47-2.5-6.57-2-.67-2.46-.7c-.52.1-1.02.3-1.47.58,0,0,2.33.08,3.13,1.52l3.29,5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m323.42,262.38c.6.65.94,1.49.96,2.37,1.02,11.94-.78,18.74-4.21,27.28,0,0-.5,2.61.6,1.86,0,0,6.16-9.58,4.59-28.74,0,0-.32-2.16.87-3.32.03-.04-2.7-.13-2.81.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m320.8,250.76c.67-.16,1.36.21,1.58.87.52,1.2,4.09,7.58,3.48,9.72s-1.15,1.38-1.96,1.66-3.21-.66-3.77-1.74c-.81-1.41-1.38-2.95-1.66-4.55-.08-1.29-1.21-5.23,2.33-5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m320.8,250.76c.67-.16,1.36.21,1.58.87.52,1.2,4.09,7.58,3.48,9.72s-1.15,1.38-1.96,1.66-3.21-.66-3.77-1.74c-.81-1.41-1.38-2.95-1.66-4.55-.08-1.29-1.21-5.23,2.33-5.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m324.31,250.11c.96-.16,1.94.17,2.61.87,1.1,1.54,1.77,3.34,1.92,5.22.06,1.88.52,6.43-3.48,6.64-3.04.17-4.44-3.7-4.94-7.04-.36-2.43,1.05-3.09,1.74-4.12.5-.77,1.26-1.33,2.14-1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m325.28,262.85s-3.17,1.1-4.98-.62-1.6-3.21-2.11-4.56c-.3-.82-.72-1.58-1.24-2.28,0,0,.98.25,2.19,2.8s3.96,4.82,6.14,4.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m307.51,252.44c1.55-.59,2.76-1.84,3.31-3.4.66-2.03.5-4.24-.44-6.16-.87-1.52-1.27-1.6-1.27-1.6,0,0-1.29-.58-2.97,1.98s-3.21,4.68-2.68,6.43c.42,1.84,2.18,3.04,4.05,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m307.51,252.44c1.55-.59,2.76-1.84,3.31-3.4.66-2.03.5-4.24-.44-6.16-.87-1.52-1.27-1.6-1.27-1.6,0,0-1.29-.58-2.97,1.98s-3.21,4.68-2.68,6.43c.42,1.84,2.18,3.04,4.05,2.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m308.44,255.03s-.49,0-1.05,2.19-2.94,16.68,2.61,28.91c0,0,.51,2.09-1.42,1.74-3.61-9.9-4.45-20.6-2.41-30.94.09-.72-.09-1.44-.49-2.04l2.76.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m312.22,249.89s1.65-2.1,1.38-4.16-.87-2.26-1.05-2.36-1.45-.12-2.41,1.48c-.76,1.06-1.21,2.32-1.28,3.63.16.65.52,1.24,1.03,1.69.78.32,1.66.21,2.34-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m312.22,249.89s1.65-2.1,1.38-4.16-.87-2.26-1.05-2.36-1.45-.12-2.41,1.48c-.76,1.06-1.21,2.32-1.28,3.63.16.65.52,1.24,1.03,1.69.78.32,1.66.21,2.34-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m313.64,244.92s.87.56.66,2.31c-.23,1.38-.71,2.7-1.4,3.91-.21.33-1.55,3.67-3.76,4.48s-2.28-.14-2.28-.14c-.75-.95-1-2.2-.69-3.37.37-1.78,1.08-3.46,2.1-4.96.94-1.31,1.38-2.08,2.54-2.3s2.53-.22,2.83.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m313.64,244.92s.87.56.66,2.31c-.23,1.38-.71,2.7-1.4,3.91-.21.33-1.55,3.67-3.76,4.48s-2.28-.14-2.28-.14c-.75-.95-1-2.2-.69-3.37.37-1.78,1.08-3.46,2.1-4.96.94-1.31,1.38-2.08,2.54-2.3s2.53-.22,2.83.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m305.44,255.48s2.05,1,3.62-1.9,1.14-4.14,1.14-4.61.31-.87.14-1.54-.44-.58-.65-1.43,0-1.93-.28-2.33c-.21-.41-.59-.7-1.04-.79-.69,0-1.38.08-2.06.2-.58,0-.73,1.07-1.21,1.39-1.26.83-2.06,2.2-2.15,3.71-.31,2.48-.51,4.15.26,5.36.48.91,1.27,1.6,2.24,1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m308.54,256.26c.35.17,1.24.48,2.73-.51,1.83-1.22,2.41-3.58,2.68-4.15.45-1.12.99-2.2,1.61-3.23.6-.78.67-1.31.59-1.41s-.98,0-1.74.87-1.98,1.59-2.61,3.08-1.23,3.73-2.36,4.35-1.99.15-1.9.64c.05.11.75.24.99.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m306.93,279.89s1.34-4.35-2.86-12.25c-4.2-7.9-7.99-10.28-7.99-10.28,0,0,0,4.41,3.73,11.72s6.56,10.48,7.12,10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m298.14,260.73c-.12-.23-.17,0-.05.22,1.49,2.81,6.63,11.27,8.28,17.11.08.24.28,0,.19-.25-3.25-9.84-6.91-14.22-8.42-17.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "299.27 310.54 338.62 310.54 336.89 292.41 336.5 288.41 301.38 288.41 301 292.41 299.27 310.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "301.12 291.14 336.89 292.41 336.5 288.41 301.38 288.41 301.12 291.14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 299.14,
    y: 285.01,
    width: 39.61,
    height: 4.82
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -28.5,
    y: 367.88,
    width: 293.68,
    height: 10.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: -17.99,
    y: 378.33,
    width: 272.65,
    height: 10.44
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "235.8 388.78 246.58 388.78 258.87 535.31 254.65 535.31 235.8 388.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "246.58 388.78 247.4 398.58 237.07 398.58 235.8 388.78 246.58 388.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: ".88 388.78 -9.9 388.78 -22.19 535.31 -17.97 535.31 .88 388.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "-9.9 388.78 -10.72 398.58 -.39 398.58 .88 388.78 -9.9 388.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -28.5,
    y: 367.88,
    width: 293.68,
    height: 10.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "246.58 388.78 247.4 398.58 237.07 398.58 235.8 388.78 246.58 388.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "-9.9 388.78 -10.72 398.58 -.39 398.58 .88 388.78 -9.9 388.78"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -1.82,
    y: 175.78,
    width: 88.79,
    height: 107.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.32,
    y: 185.61,
    width: 68.5,
    height: 88.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8.32,
    y: 185.61,
    width: 2.68,
    height: 88.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 86.97,
    y: 175.78,
    width: 2.68,
    height: 107.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m19.69,205.11c-1.05.47-1.04,1.95,0,2.41l4.81,2.11.07.03s.02,0,.02.01l4.93,2.16,1.12.49,12.57,5.51c.34.15.73.15,1.07,0l15.53-6.91,2.49-1.11.95-.42,4.88-2.17c1.05-.47,1.04-1.95,0-2.41l-23.51-10.3c-.34-.15-.73-.15-1.07,0l-23.85,10.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m26.73,211.58l-1.88-.82v11.44c0,.43.26.83.66,1l3.57,1.57v7.72c-1.41.23-2.47,1.5-2.36,3,.1,1.38,1.21,2.49,2.59,2.6,1.66.13,3.05-1.18,3.05-2.81,0-1.4-1.02-2.57-2.37-2.79v-7.32s13.32,5.84,13.32,5.84c.28.12.6.12.88,0l18.14-8.06c.4-.18.65-.57.65-1v-11.44s-.31.14-.31.14l-2.49,1.11-16.25,7.23c-.06.02-.12.04-.19.04s-.12-.01-.18-.04l-14.49-6.35-2.35-1.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m51.03,243.93c-3.21.16-6.4-.65-9.14-2.32-1.06-.64-1.73-1.77-1.78-3.01,0-3.46,5.63-5.34,10.92-5.34s10.92,1.87,10.92,5.34c-.05,1.25-.73,2.38-1.8,3.02-2.74,1.67-5.92,2.47-9.12,2.31h0Zm0-8.37c-5.26,0-8.62,1.8-8.62,3.03,0,.46.46.88.85,1.15,2.35,1.37,5.05,2.02,7.77,1.87,2.71.15,5.41-.5,7.75-1.86.4-.29.86-.72.86-1.17,0-1.23-3.37-3.02-8.62-3.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m51.03,248.11c-3.21.16-6.4-.65-9.14-2.33-1.06-.64-1.73-1.77-1.78-3.01v-4.18c0-.41.22-.79.58-1,.36-.21.8-.21,1.15,0,.36.21.58.59.58,1,0,.46.46.88.85,1.15,2.35,1.37,5.05,2.02,7.77,1.87,2.71.15,5.41-.5,7.75-1.86.4-.29.86-.72.86-1.17h0c0-.41.22-.79.58-1,.36-.21.8-.21,1.15,0,.36.21.58.59.58,1v4.19c-.05,1.25-.73,2.38-1.8,3.02-2.74,1.67-5.92,2.48-9.12,2.32h0Zm-8.62-6.15v.82c0,.46.46.88.84,1.15h0c2.35,1.37,5.05,2.02,7.77,1.88,2.71.15,5.4-.5,7.75-1.86.4-.29.86-.72.86-1.17v-.81c-2.65,1.4-5.62,2.08-8.62,1.97-2.99.12-5.97-.56-8.62-1.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m51.03,252.3c-3.21.16-6.4-.65-9.14-2.32-1.06-.64-1.73-1.77-1.78-3.01v-4.19c0-.41.22-.79.58-1,.36-.21.8-.21,1.15,0,.36.21.58.59.58,1,0,.46.46.88.84,1.15,2.35,1.37,5.05,2.02,7.77,1.88,2.71.15,5.4-.5,7.75-1.86.4-.29.86-.72.86-1.17,0-.41.22-.79.58-1,.36-.21.8-.21,1.15,0,.36.21.58.59.58,1v4.19c-.05,1.25-.73,2.38-1.8,3.02-2.74,1.67-5.92,2.48-9.12,2.32h0Zm-8.62-6.15v.81c0,.46.46.88.85,1.15,2.35,1.37,5.05,2.02,7.77,1.87,2.71.15,5.41-.5,7.75-1.86.4-.29.86-.72.86-1.17v-.81c-2.65,1.4-5.62,2.08-8.62,1.97-2.99.12-5.97-.56-8.62-1.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m51.03,256.48c-3.21.16-6.4-.65-9.14-2.33-1.06-.64-1.73-1.77-1.78-3.01v-4.19c0-.41.22-.79.58-1,.36-.21.8-.21,1.15,0,.36.21.58.59.58,1,0,.46.46.88.85,1.15,2.35,1.37,5.05,2.02,7.77,1.87,2.71.15,5.41-.5,7.75-1.86.4-.29.86-.72.86-1.17,0-.41.22-.79.58-1,.36-.21.8-.21,1.15,0,.36.21.58.59.58,1v4.19c-.05,1.25-.73,2.38-1.8,3.02-2.74,1.67-5.92,2.48-9.12,2.32h0Zm-8.62-6.15v.82c0,.46.46.88.84,1.15,2.35,1.37,5.05,2.02,7.77,1.88,2.71.15,5.4-.5,7.75-1.86.4-.29.86-.72.86-1.17v-.81c-2.65,1.4-5.62,2.08-8.62,1.97-2.99.11-5.97-.56-8.62-1.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m51.03,260.67c-3.21.16-6.4-.65-9.14-2.32-1.06-.64-1.73-1.78-1.78-3.02v-4.18c0-.41.22-.79.58-1,.36-.21.8-.21,1.15,0,.36.21.58.59.58,1,0,.46.46.88.84,1.15,2.35,1.37,5.05,2.02,7.77,1.88,2.71.15,5.4-.5,7.75-1.86.4-.29.86-.72.86-1.17h0c0-.41.22-.79.58-1,.36-.21.8-.21,1.15,0,.36.21.58.59.58,1v4.18c-.05,1.25-.73,2.38-1.8,3.02-2.74,1.67-5.92,2.48-9.12,2.32h0Zm-8.62-6.15v.81c0,.46.46.88.85,1.15,2.35,1.37,5.05,2.02,7.77,1.87,2.71.15,5.4-.5,7.75-1.86.4-.29.86-.72.86-1.17v-.81c-2.65,1.4-5.62,2.08-8.62,1.97-2.99.12-5.97-.56-8.62-1.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m51.03,264.86c-5.3,0-10.92-1.87-10.92-5.34v-4.19c0-.41.22-.79.58-1,.36-.21.8-.21,1.15,0,.36.21.58.59.58,1,0,.46.46.88.85,1.15,2.35,1.37,5.05,2.02,7.77,1.87,2.71.15,5.4-.5,7.75-1.86.4-.29.86-.72.86-1.17,0-.41.22-.79.58-1,.36-.21.8-.21,1.15,0,.36.21.58.59.58,1v4.19c0,3.48-5.63,5.35-10.92,5.35h0Zm-8.62-6.15v.81c0,1.24,3.36,3.03,8.62,3.03s8.62-1.8,8.62-3.03v-.81c-2.65,1.4-5.62,2.08-8.62,1.96-2.99.11-5.97-.56-8.62-1.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m25.53,261.67c-.82.03-1.61-.32-2.15-.94-2.1-2.44.6-8.11,4.35-12.46,3.18-3.69,6.64-5.99,9.02-5.99h0c.83-.04,1.63.3,2.18.92.74,1.02.97,2.33.6,3.54-.9,3.34-2.6,6.41-4.96,8.94-2.02,2.63-4.73,4.64-7.83,5.81-.39.11-.8.17-1.21.18h0Zm11.22-17.08c-1.39,0-4.34,1.78-7.28,5.19-4.04,4.69-4.98,8.7-4.34,9.46.2.23.79.1,1.04.04h0c2.65-1.04,4.95-2.79,6.66-5.07,2.08-2.23,3.6-4.93,4.44-7.87.18-.92.08-1.42-.08-1.61-.03-.03-.11-.13-.44-.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m28.12,264.63c-.83.04-1.63-.3-2.18-.92l-2.55-2.97c-.27-.31-.35-.74-.22-1.13.14-.39.47-.68.87-.75.4-.08.82.07,1.09.38.2.23.79.1,1.04.04,2.65-1.04,4.95-2.79,6.66-5.07,2.08-2.23,3.6-4.93,4.44-7.87.18-.92.08-1.42-.08-1.61-.21-.23-.31-.53-.3-.84.02-.31.16-.6.4-.8.23-.2.54-.3.85-.28.31.03.59.18.79.42l2.53,2.95c2.1,2.44-.6,8.13-4.36,12.48-3.17,3.69-6.62,5.97-9,5.98h.01Zm-1.09-3.2l.66.77s.11.13.44.13c1.39,0,4.33-1.78,7.26-5.17,4.05-4.7,5-8.73,4.36-9.48l-.32-.38h0c-.98,3.12-2.63,5.98-4.84,8.39-1.97,2.54-4.58,4.51-7.55,5.73h0Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStufiInside);
export default __webpack_public_path__ + "static/media/stufi-inside.73fe895199439fc1acf0b56e32e09520.svg";
export { ForwardRef as ReactComponent };